module.exports = __webpack_public_path__ + "static/media/firmly-agree.bb7d12ef.svg";